import { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import IMAGES from '../../const/images';

const { Text } = Typography;

interface LoadingProps {
    text?: string;
    fullScreen?: boolean;
}

const Loading: FC<LoadingProps> = ({ text, fullScreen = true }) => {
    const { t } = useTranslation('shared');

    return (
        <div className={`loading ${fullScreen ? 'loading--fullscreen' : 'loading--inline'}`}>
            <div className="loading__content">
                <div className="loading__logo-wrapper">
                    <img
                        src={IMAGES.logo.horizontal}
                        alt="Fleets"
                        className="loading__logo"
                    />
                    <div className="loading__bar">
                        <div className="loading__bar-progress" />
                    </div>
                </div>
                <Text className="loading__text">
                    {text || t('LOADING')}
                </Text>
            </div>
        </div>
    );
};

export { Loading };
export type { LoadingProps };
